import React, { useContext, useEffect } from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import LevelLinks from './LevelLinks'
import { courseStore } from '../../state/courseStore'
import { withRouter } from 'react-router-dom'
import Header from '../Header'
import {
  MenuContentWrapper,
  LevelMenuTitle,
  LevelsContainer
} from './LevelSelector.styled'

const levelContainerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
      delayChildren: 0.4
    }
  }
}

const LevelSelector = ({ match }) => {
  const { state } = useContext(courseStore)
  useEffect(() => {
    window.scroll({ top: 0 });
  }, [])
  return (
    <>
      <Header style={{ justifyContent: 'flex-end' }} />
      <MenuContentWrapper>
        <LevelMenuTitle>
          <FormattedHTMLMessage id='levelsMenu.title' />
        </LevelMenuTitle>
        <LevelsContainer variants={levelContainerVariants} initial='hidden' animate='visible'>
          <LevelLinks levels={state.levels} />
        </LevelsContainer>
      </MenuContentWrapper>
    </>
  )
}

export default withRouter(LevelSelector)
